import React, { useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import "../../assets/css/Dashboard.css";
import Footer from "../../components/Footer";
import Header from "../../components/Header";
import { UpdatePasswordAction } from "../../redux/actions/auth";

const ChangePassword = ({ auth, changePassword }) => {
    const [currentPassword, setCurrentPassword] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const submit = async (e) => {
        try {
            e.preventDefault();
            if (newPassword != confirmNewPassword) {
                return Swal.fire({
                    icon: "error",
                    title: "Validation",
                    text: "Password doesn't match!",
                });
            }
            changePassword(
                currentPassword,
                newPassword,
                confirmNewPassword
            ).then(() => {
                setCurrentPassword("");
                setNewPassword("");
                setConfirmNewPassword("");
            });
        } catch (e) {
            console.log(e);
        }
    };
    return (
        <>
            <Header />
            <section className="py-2 hero-wrap ">
                <div className="container">
                    <div className="row ">
                        <div className="col-md-8 col-lg-8"></div>
                    </div>
                </div>
            </section>
            <section className="py-10">
                <div id="login">
                    <h3 className="text-center text-white"></h3>
                    <div className="container">
                        <div
                            id="login-row"
                            className="row justify-content-center align-items-center py-5"
                        >
                            <div id="login-column" className="col-md-6">
                                <div id="login-box" className="col-md-12">
                                    <form
                                        id="changepasswordForm"
                                        className="form"
                                        action=""
                                        method="post"
                                        onSubmit={submit}
                                    >
                                        <h3 className="text-center text-signin bottom-border ">
                                            Change Your Password
                                        </h3>

                                        <div className="form-group pt-5">
                                            <label
                                                htmlFor="username"
                                                className=""
                                            >
                                                Current Password:
                                            </label>
                                            <br />
                                            <input
                                                type="password"
                                                placeholder="Enter your Password"
                                                name="password"
                                                id="current-password"
                                                className="form-control"
                                                required
                                                value={currentPassword}
                                                onChange={(e) =>
                                                    setCurrentPassword(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label
                                                htmlFor="password"
                                                className=""
                                            >
                                                New Password:
                                            </label>
                                            <br />
                                            <input
                                                type="password"
                                                placeholder="Enter your New Password"
                                                name="password"
                                                id="new-password"
                                                className="form-control"
                                                required
                                                value={newPassword}
                                                onChange={(e) =>
                                                    setNewPassword(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label
                                                htmlFor="password"
                                                className=""
                                            >
                                                Confirm Password:
                                            </label>
                                            <br />
                                            <input
                                                type="password"
                                                placeholder="Enter your Password"
                                                name="password"
                                                id="confirm_password"
                                                className="form-control"
                                                required
                                                value={confirmNewPassword}
                                                onChange={(e) =>
                                                    setConfirmNewPassword(
                                                        e.target.value
                                                    )
                                                }
                                            />
                                        </div>
                                        <div className="form-group text-center py-2">
                                            <input
                                                type="submit"
                                                name="Reset"
                                                className="btn btn-danger rounded-pill order-0"
                                                value="Change Now"
                                            />
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <div className="clearfix"></div>
            <Footer />
        </>
    );
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

const mapDispatchToProps = (dispatch) => ({
    changePassword: async (currentPassword, newPassword, confirmNewPassword) =>
        dispatch(
            await UpdatePasswordAction(
                currentPassword,
                newPassword,
                confirmNewPassword
            )
        ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangePassword);
